declare var require: any;

export class FileDownloader {
  public static downLoadFile(data: any, type: string, name: string) {
    const FileSaver = require('file-saver');
    const blob = new Blob(data, { type: type });
    FileSaver.saveAs(blob, name);
  }
}
